var React = require('react');

function ArrowRightButtonInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M13.293 7.293c-0.391 0.391-0.391 1.023 0 1.414l2.293 2.293h-7.586c-0.552 0-1 0.448-1 1s0.448 1 1 1h7.586l-2.293 2.293c-0.391 0.391-0.391 1.023 0 1.414 0.195 0.195 0.451 0.293 0.707 0.293s0.512-0.098 0.707-0.293l4.707-4.707-4.707-4.707c-0.391-0.391-1.023-0.391-1.414 0z"}));
}

ArrowRightButtonInline.defaultProps = {"className":"arrow-icon","version":"1.1","width":"20","height":"20","viewBox":"0 0 22 22","data-tags":"keyboard_arrow_right"};

module.exports = ArrowRightButtonInline;

ArrowRightButtonInline.default = ArrowRightButtonInline;
